export function SalaryCard({ label, value, subtext, color }) {
  return (
    <div className={`p-3 sm:p-4 rounded-2xl ${color}`}>
      <p className="text-xs font-semibold opacity-70 mb-1 uppercase tracking-wider">{label}</p>
      <p className="text-base sm:text-xl font-bold truncate" style={{ fontFamily: "'Manrope', sans-serif" }}>
        {typeof value === 'number' ? `₹${value.toLocaleString('en-IN')}` : value}
      </p>
      {subtext && <p className="text-[10px] sm:text-xs opacity-60 mt-1 truncate">{subtext}</p>}
    </div>
  );
}
